import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showText?: boolean;
  variant?: 'light' | 'dark' | 'auto';
}

export const Logo: React.FC<LogoProps> = ({
  className = '',
  size = 'md',
  showText = true,
  variant = 'auto'
}) => {
  const { theme } = useTheme();
  const resolvedVariant = variant === 'auto' ? theme : variant;
  const heightClasses = {
    sm: 'h-9',
    md: 'h-[38px]',
    lg: 'h-[45px]',
    xl: 'h-[76px]'
  };

  const textSizeClasses = {
    sm: 'text-[25.5px]',
    md: 'text-[30.6px]',
    lg: 'text-[38.8px]',
    xl: 'text-[68px]'
  };

  const subtextSizeClasses = {
    sm: 'text-[7.5px]',
    md: 'text-[8.8px]',
    lg: 'text-[11.3px]',
    xl: 'text-[16px]'
  };

  const taglineLetterSpacingClasses = {
    sm: 'tracking-wide',
    md: 'tracking-wide',
    lg: 'tracking-wide',
    xl: 'tracking-[0.18em]'
  };

  const taglineGapClasses = {
    sm: '-mt-1.5',
    md: '-mt-1.5',
    lg: '-mt-2.5',
    xl: '-mt-3'
  };

  return (
    <div className={`flex items-center space-x-0.5 ${className}`}>
      <div className={`${heightClasses[size]} flex-shrink-0`}>
        <img src={resolvedVariant === 'dark' ? '/logo-dark.png?v=4' : '/logo.png?v=4'} alt="ClinLexis" className="h-full w-auto" />
      </div>

      {showText && (
        <div className="flex flex-col min-w-0">
          <span className={`font-bold ${textSizeClasses[size]} leading-tight tracking-tight`} style={{ fontFamily: "'Nunito Sans', sans-serif" }}>
            <span className={resolvedVariant === 'dark' ? 'text-white' : 'text-medical-900 dark:text-medical-100'}>Clin</span>
            <span className={resolvedVariant === 'dark' ? 'text-white' : 'text-medical-900 dark:text-medical-100'}>Lexis</span><sup className={`text-[0.25em] font-normal opacity-50 ${resolvedVariant === 'dark' ? 'text-medical-400' : 'text-medical-400 dark:text-medical-500'}`} style={{ verticalAlign: 'super', marginLeft: '-2px' }}>™</sup>
          </span>
          {size !== 'sm' && (
            <span className={`${subtextSizeClasses[size]} font-medium uppercase ${taglineLetterSpacingClasses[size]} ${taglineGapClasses[size]} whitespace-nowrap pl-0.5 ${resolvedVariant === 'dark' ? 'text-medical-300' : 'text-medical-500 dark:text-medical-400'}`}>
              Read · Analyse · Report
            </span>
          )}
        </div>
      )}
    </div>
  );
};
